import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import StatusVerifiedIcon from '@atlaskit/icon/core/status-verified';
import type { IconSpacing } from '@atlaskit/icon/types';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

const i18n = defineMessages({
	teamVerifiedLozengeTooltip: {
		id: 'permissions-principals.team-verified-lozenge.tooltip',
		defaultMessage: 'This team is verified because it is controlled by an organization admin.',
		description: 'The text is shown as a tooltip when a user hovers over the verified lozenge badge displayed next to a team name in the permissions panel, explaining why the team has a verified status.',
	},
	groupVerifiedLozengeTooltip: {
		id: 'permissions-principals.group-verified-lozenge.tooltip',
		defaultMessage: 'This group is verified because it is controlled by an organization admin.',
		description: 'The text is shown as a tooltip when a user hovers over the verified lozenge badge displayed next to a group name in the permissions panel, explaining why the group has a verified status.',
	},
});

export const VerifiedTeamLozenge = ({
	isTeam = true,
	spacing = 'compact',
}: {
	isTeam?: boolean;
	spacing?: IconSpacing;
}) => {
	const { formatMessage } = useIntl();

	return (
		<Tooltip
			content={
				isTeam
					? formatMessage(i18n.teamVerifiedLozengeTooltip)
					: formatMessage(i18n.groupVerifiedLozengeTooltip)
			}
		>
			<StatusVerifiedIcon
				label="verified team"
				color={token('color.icon.accent.blue')}
				size="small"
				spacing={spacing}
			/>
		</Tooltip>
	);
};
